import * as assets from './assets.selector';
import editor from './editor.selector';

export default {
  assets,
  editor
};
